export default __webpack_public_path__ + "static/media/ups-inabit.4d16bc20.svg";